import { call, put, takeEvery } from 'redux-saga/effects';
import { FetchNewDealerRequests, newDealerActionCreators, NewDealerActionKeys } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { uiActionCreators } from '../../ui';
import * as api from '../newDealerApi';
import { INewDealerRequestMin } from '../newDealerInterfaces';

function* fetchNewDealerRequestsSaga(action: FetchNewDealerRequests) {
  yield put(uiActionCreators.toggleLoading('newDealerRequests'));
  const response: IApiExecuteRespone<INewDealerRequestMin[]> = yield call(api.fetchNewDealerRequests);

  if (!response.requestFailed && response.value) {
    yield put(newDealerActionCreators.setRequestMins(response.value));
  } else {
    // TODO - show error message
  }
  yield put(uiActionCreators.toggleLoading('newDealerRequests'));
}

export function* watchFetchNewDealerRequests() {
  yield takeEvery(NewDealerActionKeys.FETCH_NEW_DEALER_REQUESTS, fetchNewDealerRequestsSaga);
}
